export var LocalStorageItems;

(function (LocalStorageItems) {
  LocalStorageItems["JOB_QUEUE_CHECKOUT"] = "job_queueCheckout";
  LocalStorageItems["CHECKOUT"] = "data_checkout";
  LocalStorageItems["PAYMENT"] = "data_payment";
})(LocalStorageItems || (LocalStorageItems = {}));